import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {
  CommentDTO, CommentModel, mapCommentStatus,
  CommentUpdateDTO
} from '../models/comment-model';
import { User } from '../models/user-model';
import { Check, phaseToCheckStatus } from '../models/checks-model';
import { API_ENDPOINTS } from '../common/api/api-endpoints';

/**
 * CommentService
 *
 * Schlanke API-Schicht für kommentar-bezogene HTTP-Operationen und das Mapping DTO → Model.
 * Der Kommentar-State wird vom PendingCheckCommentStore (NgRx Signal Store) verwaltet.
 */
@Injectable({
  providedIn: 'root',
})
export class CommentService {
  private readonly http = inject(HttpClient);

  // ===== Backend API Methoden =====

  /** PUT /comment/{guid} – aktualisiert isDone und/oder severity */
  updateCommentApi(guid: string, payload: CommentUpdateDTO): Observable<CommentDTO> {
    return this.http.put<CommentDTO>(`${API_ENDPOINTS.COMMENT}/${guid}`, payload);
  }

  /**
   * DELETE /comment/{guid} ist nicht in der OpenAPI-Spec.
   */
  deleteCommentApi(guid: string): Observable<void> {
    return this.http.delete<void>(`${API_ENDPOINTS.COMMENT}/${guid}`);
  }

  // ===== Model-Mapping =====

  mapComment(
    dto: CommentDTO,
    usersByOid: Map<string, User>,
    _checksById: Map<string, Check>
  ): CommentModel {
    const status = mapCommentStatus(dto.isDone, dto.severity);
    const checkStatus = dto.stage ? phaseToCheckStatus(dto.stage.phase) : 0;

    return {
      id: dto.guid,
      content: dto.text,
      status,
      createdAt: dto.createdAt,
      severity: dto.severity,
      isDone: dto.isDone,
      checkStatus,
      check: null!,
      documents: [],
      author: usersByOid.get(dto.author.oid) ?? {
        oid: dto.author.oid,
        displayName: dto.author.displayName,
        egeckoId: '',
        createdAt: '',
        lastAccessAt: '',
        roles: [],
        scopes: [],
        department: null,
      } as User,
      isCheckImpossible: dto.severity === 'CRITICAL',
    };
  }
}

